// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loadingButton[data-v-08378fde] {\n  padding: 0.42667rem 0;\n  color: #fff;\n  text-align: center;\n  font-size: 0.42667rem;\n  font-weight: 500;\n  border-radius: 0.8rem;\n  background: #0c8027;\n}\n.disabled[data-v-08378fde] {\n  background: #bebebe;\n}\n.loading[data-v-08378fde] {\n  padding: 0.36rem 0;\n}\n", ""]);
// Exports
module.exports = exports;
